export namespace RegionLabel {
    export const fontSize = (): number => 9
    export const labelHeight = (): number => Math.ceil(fontSize() * 1.5)
}